
import {  AxiosQUANTUM,  AxiosMULEEX,  orgId, userId  } from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";


export const rolesAndPrivilegesApiFactory = {

 
  $_getCreateUserRoles(){
     let url = `/roles/${orgId()}/muleex`;
    return AxiosQUANTUM.get(url);
  },
  $_confirmUserPassword(payload){
    let url = 'org/security/passwords/confirm'
    return AxiosQUANTUM.post(url, payload)
  },
  $_requestOTP(payload){
    let url = 'org/security/passwords/confirm-root-admin'
    return AxiosQUANTUM.post(url, payload)
  },

   $_getPrivileges() {
    let url = "/roles/privileges";
    return AxiosMULEEX.get(url);
  },
   $_getModulesAndPrivileges() {
    let url = "/setting/role-privilege/module";
    return AxiosMULEEX.get(url);
  },
  
  $_getRolePrivileges(roleId) {
    let url = `/roles/${roleId}/privileges`;
    return AxiosQUANTUM.get(url);
  },
  $_createRole(payload) {
    let url = "/roles";
    
    return AxiosMULEEX.post(url, payload);
  },
 
   $_transferOwnership(payload) {
    let url = "/roles/transferownership";
    return AxiosMULEEX.post(url, payload);
  },
  $_roleAndPrevelidgeTransferOwnership(payload) {
    let url = "/setting/role-privilege/transfer-ownership";
    return AxiosMULEEX.post(url, payload);
  },
 
   $_getRoles(params) {
    let url = `/roles/creator/${userId()}${appendQueryParams(
          params
        )}`;
    return AxiosMULEEX.get(url);
  },
   $_viewRole(roleId) {
    let url = `/roles/getrole/${roleId}`;
    return AxiosMULEEX.get(url);
  },


  $_getRoleAndItsPrivileges(roleId) {
    let url = `/roles/${roleId}/privileges`;
    return AxiosQUANTUM.get(url);
  },
  $_getRoleAndItsPriveledgeById(roleId){
    let url = `/roles/${roleId}/privileges`;
    return AxiosQUANTUM.get(url);
  },
  $_getRoleAndItsUsers(roleId) {
    let url = `/org/${orgId()}/users?app=muleex&roleId=${roleId}`;
    return AxiosQUANTUM.get(url);
  },
  $_newGetRolesAndItsUsers(roleId){
    let url = `/roles/${roleId}/muleex/members-count`;
    return AxiosQUANTUM.get(url);
  },

   $_deleteRole(roleId) {
    let url = `/roles/deleterole/${roleId}`;
    return AxiosMULEEX.delete(url);
  },
 
  
  $_getUsersInRole(roleId) {
    let url = `/roles/users/${roleId}`;
    return AxiosQUANTUM.get(url);
  },

  $_updateRole(payload) {
    let url = "/roles/update";
    return AxiosMULEEX.put(url, payload);
  },
};
